import { Platform, View, ViewProps } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { cn } from '@/lib/utils';

export interface FullHeightWrapperProps extends ViewProps {}

export const FullHeightWrapper = ({
  className,
  style,
  ...props
}: FullHeightWrapperProps) => {
  const insets = useSafeAreaInsets();
  // The floating tab bar lifts itself above the Android system nav bar by the
  // bottom safe-area inset (see TabBar). Grow the bottom reservation by the same
  // inset so bottom-anchored content (e.g. the chat input) still clears the bar
  // instead of being overlapped. Web renders the sidebar layout (md:pb-0) with no
  // floating bar, so it keeps the Tailwind-only padding.
  const androidNavInset = Platform.OS === 'android' ? insets.bottom : 0;
  return (
    <View
      {...props}
      className={cn(
        className,
        'flex flex-col bg-background flex-1 pb-24 md:pb-0',
      )}
      style={
        androidNavInset
          ? [style, { paddingBottom: 72 + androidNavInset }]
          : style
      }
    />
  );
};
